import { PermissionName } from '@vetahealth/fishing-gear/permissions'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Dashboard as AnalyticsComponent } from '../../components/Widgets/Analytics'
import { useUserStore } from '../../stores/user'
import { routes } from '.'

export function Analytics(): React.ReactNode {
  const navigate = useNavigate()
  const [hasSomePermission] = useUserStore((state) => [state.hasSomePermission])

  useEffect(() => {
    if (!hasSomePermission(PermissionName.accessAnalytics)) {
      navigate(routes.patientList(), { replace: true })
      return
    }
  }, [])

  return <AnalyticsComponent />
}
